import { useRef, useState } from 'react'
import { base64ToBlob } from '../helpers/common'
import { useAppDispatch } from 'app/hooks/reduxHooks'
import { setImageDataUrl, setImageUrl, setSourceType } from 'app/farmer360/store/app'

export interface UseImageUploadReturn {
  uploadFromCamera: () => void
  uploadFromGallery: () => void
}

const useImageUpload = (
  onImageReady?: (
  ) => void,
): UseImageUploadReturn => {
  const dispatch = useAppDispatch()
  let imageSourceType = true

  const uploadFromCamera = async () => {
    imageSourceType = false
    const input = document.createElement('input')
    input.type = 'file'
    input.accept = 'image/*'
    input.capture = 'environment'
    input.onchange = (event: any) => {
      const file = event.target.files?.[0]
      if (file) handleFileSelected(file)
    }
    input.click()
  }

  const uploadFromGallery = () => {
    const input = document.createElement('input')
    input.type = 'file'
    input.accept = 'image/*'

    input.onchange = (event: any) => {
      const file = event.target.files?.[0]
      if (file) handleFileSelected(file)
    }

    input.click()
  }

  const handleFileSelected = (file: File) => {
    const reader = new FileReader()
    reader.onload = e => {
      const base64 = e.target?.result as string
      const blob = base64ToBlob(base64)
      const url = URL.createObjectURL(blob)   
      dispatch(setImageUrl(url))
      dispatch(setSourceType(imageSourceType))
      dispatch(setImageDataUrl(base64))
      onImageReady?.()
    }

    reader.readAsDataURL(file)
  }

  return {
    uploadFromCamera,
    uploadFromGallery,
  }
}

export default useImageUpload
